<template>
    <div>


        <div class="custom-table">

            <div class="row no-gutters custom-table__body">
                <template v-for="program in sortedPrograms()">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm-6">
                        <div class="custom-table__body--elem" v-html="programName(program)"></div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'quantity') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ quantity(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ linePrice(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ priceFormat(getProgramPrice(program.id, '', licenceType, program.product, program[licenceType] * 3), true) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </template>
                <template v-for="program in sortedExistingPrograms()">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm-6">
                        <div class="custom-table__body--elem" v-html="existingProgramName(program)"></div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'quantity') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ program.quantity }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ priceFormat(getProgramPrice(program.program_id, '', licenceType, program.product, 1 * 3), true) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ priceFormat(getProgramPrice(program.program_id, '', licenceType, program.product, program.quantity * 3), true) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </template>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        methods: {
            sortedPrograms() {
                return  _.sortBy(this.programs, [function(o) { return o.sortOrder; }]).reverse();
            },
            sortedExistingPrograms() {
                return  _.sortBy(this.existingPrograms, [function(o) { return o.sortOrder; }]).reverse();
            },
            quantity(program) {
                return _.isNil(program[this.licenceType]) ? 0 : program[this.licenceType]
            },
            linePrice(program) {
                return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, 3), true)
            },
            programName(program) {
                let data = {
                    'id': program.id,
                    'product': program.product,
                    'type': 'perpetual_license'
                };
                let name = this.getProgramCartName(data);
                return name;
                //return this.getProgramName(program.id,  program.product);
            },
            existingProgramName(program) {
                let data = {
                    'id': program.program_id,
                    'product': program.product,
                    'type': 'perpetual_license'
                };
                let name = this.getProgramCartName(data);
                return name;
                //return this.getProgramName(program.id,  program.product);
            }
        },
        beforeMount() {
            this.programs = _.filter(this.programs, {product: this.product.id, perpetual_upgrade: true});
            this.existingPrograms = _.filter(this.existingPrograms, {product: this.product.id});
        },
        computed: {

        },
        data() {
            return {
                products: window.jsonProducts,
                programs: this.$store.state.cart.programs,
                licenceType: this.getQtyName('lease', 'cloud'),
                existingPrograms: this.$store.state.cart.perpetualUpgrade,
            };
        },
        props: {
            product: Object
        }
    }
</script>
